import { Grid2 as Grid, TextField, GridSize, Autocomplete } from "@mui/material"
import React from "react"
import { cacheUtils } from "../../../../../../../../.."
import useDebugInformation from "../../../../../../../../../hooks/useDebugInformation"
import { ui } from "../../../../../../../../../interfaces/interfaces"
import { useAppSelector } from "@store/hooks"
import { CacheTypes } from "@utils/cache/interfaces"
import { StringProcessor } from "@utils/stringProcessor"

type MemoizedInputProps = {
    parent: string
    prefix: "CarePlanPlanDetailsProperty"
    tabName: "PropertyTab"
    inputName: "Bathrooms" | "Bedrooms" | "ExternalDoors" | "GasAppliances" | "Radiators" | "GasSafetyDueDate"
    xs: GridSize
    sm: GridSize
    type?: string
}

type MemoizedDropdownInputProps = Omit<MemoizedInputProps, "inputName"> & {
    inputName: "BuildingTypes"
}

const dropdownChange = (v: CacheTypes.BuildingTypes | null) => {
    ui.CarePlanPlanDetailsPropertyBuildingTypes = v || undefined
}

export const MemoizedDropdownInput = React.memo<MemoizedDropdownInputProps>(({ parent, prefix, inputName, xs, sm }) => {
    const value = useAppSelector(({ ui }) => ui[`${prefix}${inputName}`])
    const options = cacheUtils.getCache<CacheTypes.BuildingTypes>(inputName);
    const valid = useAppSelector(({ state }) => state[`${prefix}${inputName}Valid`])

    const helperText = useAppSelector(({ ui }) => ui[`${prefix}${inputName}HelperText`])

    useDebugInformation(`${parent}▷[${inputName}]`, { inputName, parent, prefix, xs, sm, options })
    return (<Grid size={{ xs, sm }}>
        <Autocomplete
            id={`combo-box-${inputName}`}
            options={options}
            getOptionLabel={option => option?.description ? option.description : ""}
            onChange={((e, v) => dropdownChange(v))}
            isOptionEqualToValue={(option, value) => option.description === value.description}
            value={value !== undefined ? value : null}
            renderInput={(params: any) => <TextField required {...params} label={StringProcessor.camelToWords(inputName)} name={StringProcessor.camelToWords(inputName)} error={!valid} color={valid ? "primary" : "error"} helperText={!valid ? helperText : ""} />}
        />
    </Grid>)
})